/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CommodityGroupsSummaryResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class CommodityGroupsSummaries<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetCommodityGroupsSummary
   * @request GET:/commodityGroups-summaries
   * @secure
   */
  getCommodityGroupsSummary = (params: RequestParams = {}) =>
    this.request<CommodityGroupsSummaryResponse, any>({
      path: `/commodityGroups-summaries`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommodityGroupsSummaries
   * @request OPTIONS:/commodityGroups-summaries
   */
  optionsCommodityGroupsSummaries = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodityGroups-summaries`,
      method: 'OPTIONS',
      ...params,
    });
}
